// バージョン管理システム
export interface VersionInfo {
  system: string;
  frontend: string;
  backend: string;
  database: string;
  buildTime: string;
  gitCommit?: string;
  deployDatetime?: string;
}

// 環境変数からバージョン情報を取得（ビルド時埋め込み）
export const getVersionInfo = (): VersionInfo => {
  return {
    system: process.env.REACT_APP_SYSTEM_VERSION || '1.0.0',
    frontend: process.env.REACT_APP_FRONTEND_VERSION || '1.0.0-fe.1',
    backend: process.env.REACT_APP_BACKEND_VERSION || '1.0.0-be.1',
    database: process.env.REACT_APP_DATABASE_VERSION || '1.0.0-db.1',
    buildTime: process.env.REACT_APP_BUILD_TIME || '',
    gitCommit: process.env.REACT_APP_GIT_COMMIT || undefined,
    deployDatetime:
      process.env.REACT_APP_DEPLOY_DATETIME ||
      process.env.REACT_APP_BUILD_TIME ||
      undefined,
  };
};

/** 短い commit + デプロイ日時（フッタ用）。欠落時は system のみ. */
export const getShortVersion = (): string => {
  const version = getVersionInfo();
  const commit = (version.gitCommit || '').trim().slice(0, 7);
  const deployed = (version.deployDatetime || version.buildTime || '').trim();
  const parts: string[] = [];
  if (commit) {
    parts.push(commit);
  } else {
    parts.push(`v${version.system}`);
  }
  if (deployed) {
    parts.push(deployed);
  }
  return parts.join(' · ');
};

// 詳細バージョン表示（開発者用）
export const getDetailedVersion = (): string => {
  const version = getVersionInfo();
  return `System: ${version.system} | FE: ${version.frontend} | BE: ${version.backend}`;
};

// コンポーネント別バージョン追跡
export const ComponentVersions = {
  HEADER: '1.0.1',
  NAVIGATION: '1.0.2',
  DASHBOARD: '1.0.0',
  JOURNAL: '1.0.3',
  KAMOKU: '1.0.1',
  DAIKUBUN: '1.0.1',
  BALANCE_SHEET: '1.0.1',
} as const;

// バージョン比較ユーティリティ
export const compareVersions = (v1: string, v2: string): number => {
  const parts1 = v1.split('.').map(Number);
  const parts2 = v2.split('.').map(Number);

  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const part1 = parts1[i] || 0;
    const part2 = parts2[i] || 0;

    if (part1 > part2) return 1;
    if (part1 < part2) return -1;
  }

  return 0;
};

/** 実行中バックエンドの /api/version を取得（失敗時は null）. */
export async function fetchBackendVersion(
  apiFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>
): Promise<{ git_commit?: string; deploy_datetime?: string; display?: string } | null> {
  try {
    const fetchFn = apiFetch || fetch;
    const res = await fetchFn('/api/version');
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}
